// fearGreedConst.js
// Bundled consts for the Fear & Greed domain (umlConst-style, see Development.Patterns rk=a786510f).
const fearGreedConst = {
    SEGMENTS: [
        { max: 20, label: 'Extreme fear', shortLabel: 'Xp fear', color: '#EF1414', icon: 'scream' },
        { max: 40, label: 'Fear', shortLabel: 'Fear', color: '#E2514A', icon: 'worried' },
        { max: 60, label: 'Neutral', shortLabel: 'Neutral', color: '#FAC775', icon: 'neutral' },
        { max: 80, label: 'Greed', shortLabel: 'Greed', color: '#C7D96B', icon: 'smile' },
        { max: 100, label: 'Extreme greed', shortLabel: 'Xp greed', color: '#F0D9A0', icon: 'money' },
    ],
    METER_BLOCK_COUNT: 18,
};

export default fearGreedConst;
